import { action, makeObservable, observable } from 'mobx';

class TournamentStore {
  tournamentId = null;

  constructor() {
    makeObservable(this, {
      tournamentId: observable,
      setTournamentId: action.bound,
    });
  }

  setTournamentId(id) {
    this.tournamentId = id;
  }
}

export const tournamentStore = new TournamentStore();
